<p-autoComplete
  *ngIf="!multiple"
  [(ngModel)]="_value"
  (ngModelChange)="changeValue($event)"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [inputStyleClass]="inputStyleClass"
  [panelStyleClass]="panelStyleClass"
  [suggestions]="suggestions"
  [field]="field"
  [virtualScroll]="virtualScroll"
  [virtualScrollItemSize]="virtualScrollItemSize"
  [dataKey]="dataKey"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [multiple]="multiple"
  [dropdown]="dropdown"
  [autofocus]="autofocus"
  (onSelect)="changeValue($event)"
  (completeMethod)="completeMethod.emit($event)"
  (onBlur)="onBlur()"
  (onClear)="onClear()">
  <ng-container *ngIf="itemTemplate">
    <ng-template
      pTemplate="item"
      let-item
      let-index="index">
      <ng-template
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ item: item, index: index }"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="groupTemplate">
    <ng-template
      pTemplate="group"
      let-item>
      <ng-template
        [ngTemplateOutlet]="groupTemplate"
        [ngTemplateOutletContext]="{ item: item }"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="selectedItemTemplate">
    <ng-template
      pTemplate="selectedItem"
      let-item>
      <ng-template
        [ngTemplateOutlet]="selectedItemTemplate"
        [ngTemplateOutletContext]="{ item: item }"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="headerTemplate">
    <ng-template pTemplate="header">
      <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="footerTemplate">
    <ng-template pTemplate="footer">
      <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
    </ng-template>
  </ng-container>
</p-autoComplete>

<p-autoComplete
  *ngIf="multiple"
  [(ngModel)]="_arrayValue"
  (ngModelChange)="changeValue($event)"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [inputStyleClass]="inputStyleClass"
  [panelStyleClass]="panelStyleClass"
  [suggestions]="suggestions"
  [field]="field"
  [virtualScroll]="virtualScroll"
  [virtualScrollItemSize]="virtualScrollItemSize"
  [dataKey]="dataKey"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [multiple]="multiple"
  [dropdown]="dropdown"
  (completeMethod)="completeMethod.emit($event)">
  <ng-container *ngIf="itemTemplate">
    <ng-template
      pTemplate="item"
      let-item
      let-index="index">
      <ng-template
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ item: item, index: index }"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="groupTemplate">
    <ng-template
      pTemplate="group"
      let-item>
      <ng-template
        [ngTemplateOutlet]="groupTemplate"
        [ngTemplateOutletContext]="{ item: item }"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="selectedItemTemplate">
    <ng-template
      pTemplate="selectedItem"
      let-item>
      <ng-template
        [ngTemplateOutlet]="selectedItemTemplate"
        [ngTemplateOutletContext]="{ item: item }"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="headerTemplate">
    <ng-template pTemplate="header">
      <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="footerTemplate">
    <ng-template pTemplate="footer">
      <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
    </ng-template>
  </ng-container>
</p-autoComplete>
